import React, { useEffect, useRef, useState } from "react";
import "../sections.css";
// Ruta corregida según tu indicación
import { getTarjetasInicio } from "../../../../config/services/strapi/home";
import TextSkeleton from "../../../../components/Skeleton/TextSkeleton";
import ImageSkeleton from "../../../../components/Skeleton/ImageSkeleton";

export default function QuienesSomos() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      try {
        const tarjetas = await getTarjetasInicio();
        const tarjetaQuienes = tarjetas.find(
          (t: any) => t.titulo === "QUIÉNES SOMOS"
        );
        setData(tarjetaQuienes);
      } catch (error) {
        console.error("Error cargando datos de Strapi:", error);
      } finally {
        setLoading(false);
      }
    }
    loadData();
  }, []);

  useEffect(() => {
    if (loading || !data) return;

    const video = videoRef.current;
    if (!video) return;

    const handleResize = () => {
      if (window.innerWidth < 769) {
        video.pause();
      } else {
        video.play();
      }
    };

    const onPlay = () => setIsPlaying(true);
    const onPause = () => setIsPlaying(false);

    video.addEventListener('play', onPlay);
    video.addEventListener('pause', onPause);
    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      video.removeEventListener('play', onPlay);
      video.removeEventListener('pause', onPause);
      window.removeEventListener("resize", handleResize);
    };
  }, [loading, data]);

  const togglePlay = () => {
    if (videoRef.current) {
      videoRef.current.paused ? videoRef.current.play() : videoRef.current.pause();
    }
  };

  const videoUrl = data?.video?.url || null;

  return (
    <section className="section quienes-somos-hero">
      <div className="section-inner">
        <div className="col-text">
          {loading ? <TextSkeleton className="relative z-[99999] pointer-events-none" /> : <h1>{data?.Titulo || "QUIÉNES SOMOS"}</h1>}
          <a href="/quienes-somos" className="full-link" aria-label="Ir a Quiénes Somos" />
        </div>

        <div className="col-media">
          {loading ? (
            <ImageSkeleton className="h-full relative z-[99999] pointer-events-none" />
          ) : videoUrl && (
            <video
              ref={videoRef}
              src={videoUrl}
              className="media-cover-quienes-somos"
              preload="metadata"
              playsInline
              muted
              loop
            />
          )}

          {!isPlaying && videoUrl && (
            <button
              type="button"
              className="absolute-center-play"
              onClick={togglePlay}
              aria-label="Reproducir o pausar video"
              style={{ cursor: 'pointer', zIndex: 10, background: 'transparent', border: 0, padding: 0 }}
            >
              <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <circle className="circle-outline" cx="50" cy="50" r="45" />
                <path className="play-shape" d="M40,30l30,20L40,70V30z" />
              </svg>
            </button>
          )}
          <a href="/quienes-somos" className="full-link" aria-label="Ir a Quiénes Somos" />
        </div>
      </div>
    </section>
  );
}